export default {
    data : [
        {
            id:'data_pelanggan', type:'info', label:'Master Pelanggan', hidden: 'no',
            child: [
                {id:'id', content_text: 'text', type:'text', label:'Id', hidden: 'yes'},
                {id:'nama_pelanggan', content_text: 'text', type:'text', label:'Nama Pelanggan', hidden: 'no'},
                {id:'no_urut_lokal', content_text: 'number', type:'text', label:'No Urut', hidden: 'no'},
                {id:'alamat_ip', content_text: 'text', type:'text', label:'Alamat Ip', hidden: 'no'},
                {id:'nomor_pemasangan', content_text: 'text', type:'text', label:'Nomor Pemasangan', hidden: 'no'},
                {id:'alamat_pemasangan', content_text: 'text', type:'text', label:'Alamat Pemasangan', hidden: 'no'},
                {id:'keterangan', content_text: 'text', type:'text', label:'Keterangan', hidden: 'no'},
                { 
                    id:'status', content_text: 'text', 
                    type:'radio_button', 
                    label:'Status', 
                    hidden: 'no', 
                    property:['Aktif', 'Non-Aktif'], 
                    value:['AKTIF', 'NON-AKTIF']
                },
                {id:'kategori_id', content_text: 'text', type:'text_props', label:'Kecamatan Id', hidden: 'yes' , get_data: 'getModalKategoriData().kategori_id', disabled: true},
                {id:'kategori', content_text: 'text', type:'group_text_modal', label:'Kategori', hidden: 'no', disabled: true, modal_function: 'setModalKategori', get_data: 'getModalKategoriData().kategori_name'},
                {id:'klasifikasi', content_text: 'text', type:'text_props', label:'Klasifikasi', hidden: 'no', disabled: "true",},
                {id:'klasifikasi_id', content_text: 'text', type:'text_props', label:'Klasifikasi', hidden: 'yes', disabled: "true",},
                {id:'sub_klasifikasi', content_text: 'text', type:'text_props', label:'Sub Klasifikasi', hidden: 'no', disabled: "true",},
                {id:'sub_klasifikasi_id', content_text: 'text', type:'text_props', label:'Klasifikasi', hidden: 'yes', disabled: "true",},
                // { 
                //     id:'klasifikasi_id', 
                //     content_text: 'text', 
                //     type:'select_box', 
                //     label:'Klasifikasi', 
                //     hidden: 'no', 
                //     url : '/data/:id/klasifikasi', 
                //     value_id : 'id', 
                //     value_name : 'nama'
                // },
                {id:'max_download', content_text: 'number', type:'text', label:'Max Download', hidden: 'no'},
                {id:'max_upload', content_text: 'number', type:'text', label:'Max Upload', hidden: 'no'},

 
            ]
        }
    ]
}